import { createContext, useContext, useState, useEffect } from "react";
import axios from "axios";
import { API_URL } from "./config";

const AppConfigContext = createContext({ appName: "VotaSegur", logoUrl: "", adminEmail: "" });

export const useAppConfig = () => useContext(AppConfigContext);

export const AppConfigProvider = ({ children }) => {
  const [config, setConfig] = useState({ appName: "VotaSegur", logoUrl: "", adminEmail: "" });

  useEffect(() => {
    axios
      .get(`${API_URL}/api/public/app-config`)
      .then((res) => {
        setConfig({
          appName: res.data.app_name || "VotaSegur",
          logoUrl: res.data.logo_url || "",
          adminEmail: res.data.admin_email || "",
        });
      })
      .catch(() => {});
  }, []);

  return (
    <AppConfigContext.Provider value={config}>
      {children}
    </AppConfigContext.Provider>
  );
};
